module.exports = __webpack_public_path__ + "static/img/alex-kotliarskyi-QBpZGqEMsKg-unsplash.08b8c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alex-kotliarskyi-QBpZGqEMsKg-unsplash.png
// module id = 23IP
// module chunks = 1